import FilterSummary from './FilterSummary';

export default FilterSummary;
